/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  visibility: hidden;

  // IE Edge 18 fix
  @supports (-ms-ime-align: auto) {
    visibility: visible;
  }

  @include slotted-margins("*:not([slot])");
}

.#{$prefix}tab-pane {
  display: none;
  color: v(textColor);

  &.#{$prefix}active {
    display: block;
  }
}

::slotted(eon-ui-headline) {
  color: v(textColor);
}
